import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye,faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import TableLoader from './Loader/TableLoader';

interface Item {
  id: number;
  category: string;
  sub_category?: string;
  title: string;
  author: string;
  status: string;
  // Add more properties as per your item structure
}

interface currentLatestTableProps {
  items: Item[];
  loading: boolean;
  onView: (id: number) => void;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

export default function CurrentLatestTable({
  items,
  loading,
  onView,
  onEdit,
  onDelete,
}: currentLatestTableProps) {
  const [latestPage, setLatestPage] = useState(1);
  const latestPerPage = 10;
  const totalPages = Math.ceil(items.length / latestPerPage);
  const indexOfLastLatest = latestPage * latestPerPage;
  const indexOfFirstLatest = indexOfLastLatest - latestPerPage;
  // const currentLatest = items.slice(indexOfFirstLatest, indexOfLastLatest);
  const currentLatest = items.slice(indexOfFirstLatest, indexOfLastLatest);

  const nextLatestPage = () => {
    if (latestPage < totalPages) {
      setLatestPage(latestPage + 1);
    }
  };

  const prevLatestPage = () => {
    if (latestPage > 1) {
      setLatestPage(latestPage - 1);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [latestPage]);

  return (
    <>
      {loading ?
        (
          <TableLoader />
        )

        :

        (
          <table>
            <thead>
              <tr>
                <th style={{ width: '20%' }}>Category</th>
                <th style={{ width: '20%' }}>Sub Category</th>
                <th style={{ width: '20%' }}>Title</th>
                <th style={{ width: '20%' }}>Author</th>
                <th style={{ width: '10%' }}>Status</th>
                <th style={{ width: '10%' }} className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentLatest.length !== 0 ?
                (
                  currentLatest.map( (item) => item.status === "Approved" && (
                    <tr key={item.id}>
                      <td>{item.category}</td>
                      <td>{item.sub_category}</td>
                      <td>{item.title}</td>
                      <td>{item.author}</td>
                      <td>{item.status}</td>
                      <td className="text-center">
                        <button
                          onClick={() => onView(item.id)}
                          // className="bg-red-600 rounded-sm text-white text-xl mr-2"
                          data-tooltip-id="preview">
                          <FontAwesomeIcon icon={faEye} className="text-sx text-white bg-red-600 rounded-md p-1 mr-2" />
                          {/* <BsEye /> */}
                        </button>

                        <button
                          onClick={() => onEdit(item.id)}
                          // className="bg-red-600 rounded-sm text-white text-xl mr-2"
                          data-tooltip-id="edit">
                          <FontAwesomeIcon icon={faPenToSquare} className="text-sx text-white bg-red-600 rounded-md p-1 mr-2" />
                          {/* <BsPencilSquare /> */}
                        </button>

                        <button
                          onClick={() => onDelete(item.id)}
                          type="button"
                          // className="bg-gray-600 rounded-sm text-white text-xl"
                          data-tooltip-id="delete">
                          <FontAwesomeIcon icon={faTrash} className="text-sm text-white bg-gray-600 rounded-md p-1" />
                          {/* <BsTrash /> */}
                        </button>
                      </td>
                    </tr>
                  ))
                )

                :

                (
                  <tr>
                    <td colSpan={6} className="text-center">No data available!</td>
                  </tr>
                )
              }
            </tbody>
          </table>
        )
      }

      {totalPages > 1 && (
        <div className="flex justify-center items-center mt-4 space-x-4">
          <button
            onClick={() => setLatestPage(1)}
            className="px-3 py-1 rounded bg-gray-500 text-white disabled:opacity-50"
            disabled={latestPage === 1}>
            First
          </button>

          <button
            onClick={prevLatestPage}
            className="px-3 py-1 rounded bg-gray-500 text-white disabled:opacity-50"
            disabled={latestPage === 1}>
            Previous
          </button>

          {/* Numbered page buttons */}
          {[...Array(totalPages)].map((_, index) => {
            const pageNum = index + 1;
            const range = 1; // Adjust to show more or fewer page buttons
            const show = pageNum >= latestPage - range && pageNum <= latestPage + range;

            if (show) {
              return (
                <button
                  key={pageNum}
                  onClick={() => setLatestPage(pageNum)}
                  className={`px-3 py-1 rounded ${
                    latestPage === pageNum
                      ? "bg-red-600 text-white"
                      : "bg-gray-200 text-black"
                  }`}
                >
                  {pageNum}
                </button>
              );
            }
            return null;
          })}

          <button
            onClick={nextLatestPage}
            className="px-3 py-1 rounded bg-red-500 text-white disabled:opacity-50"
            disabled={latestPage === totalPages}>
            Next
          </button>

          <button
            onClick={() => setLatestPage(totalPages)}
            className="px-3 py-1 rounded bg-red-500 text-white disabled:opacity-50"
            disabled={latestPage === totalPages}>
            Last
          </button>
        </div>
      )}
    </>
  );
}
